import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M2.47 2.472a.75.75 0 0 1 1.06 0L6.338 5.28A11.2 11.2 0 0 1 12 3.752c5.097 0 9.4 3.39 10.784 8.035a.75.75 0 0 1 0 .428 11.26 11.26 0 0 1-3.858 5.653l2.604 2.604a.75.75 0 0 1-1.06 1.06l-18-18a.75.75 0 0 1 0-1.06m15.386 14.326A9.77 9.77 0 0 0 21.28 12 9.755 9.755 0 0 0 7.44 6.382l2.492 2.492a3.75 3.75 0 0 1 5.197 5.197zm-3.825-3.825a2.25 2.25 0 0 0-3.001-3.001z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M4.464 7.652a.75.75 0 0 1 .089 1.057 9.7 9.7 0 0 0-1.833 3.295 9.755 9.755 0 0 0 11.938 6.382.75.75 0 0 1 .408 1.443c-.976.276-2.005.423-3.067.423-5.097 0-9.4-3.388-10.783-8.034a.75.75 0 0 1 0-.428 11.2 11.2 0 0 1 2.191-4.05.75.75 0 0 1 1.057-.088"
    }, null, -1)
  ])))
}
export default { render: render }